export default function Unknown(props) {
    return (
        <div className="error">
            <div className="error-container">
                <div className="error-header">
                    <h2>We didn´t find any data</h2>
                </div>
                <div className="error-body">
                    <p>Currently there are no data available</p>
                </div>
            </div>
        </div>
    )
}